/**
 * index.js
 * Written by: Alex Kasemir
 * Combines all of the reducers contained in this directory
 */
import { combineReducers } from 'redux';
import byId from './byId';
import selected from './selected';

export default combineReducers({
  byId,
  selected,
});
